<script>
export default {
  props: {
    propertyRow: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getInspectionAttachments(row) {
      row.inspectionVisible = !row.inspectionVisible;
      if (row.inspectionVisible) {
        row.propertyInspections.forEach((inspect) => {
          inspect.inspectionFiles = [];
          inspect.attachmentLoading = true;
          this.$store
            .dispatch("filemanager/GetFiles", {
              id: inspect.id,
              type: "Property Inspection",
            })
            .then((res) => {
              inspect.attachmentLoading = false;
              inspect.inspectionFiles = res.data;
            })
            .catch(() => {
              inspect.attachmentLoading = false;
              this.showToast("Something went wrong - Getting documents!", "error");
            });
        });
      }
    },
    openDocument(x) {
      this.readFile(x.id)
    },
  },
};
</script>

<template>
  <div>
    <b-card-body
      class="border cursor-pointer"
      @click="getInspectionAttachments(propertyRow)"
    >
      <div class="d-flex align-items-center justify-content-between">
        <h6 class="mb-0">
          <i class="bx bx-show"></i>
          Inspection History
        </h6>
        <h5 class="mb-0">
          <i
            class="bx bx-chevron-right rotate"
            :class="{
              'rotate-90': propertyRow.inspectionVisible,
            }"
          ></i>
        </h5>
      </div>
    </b-card-body>
    <b-collapse :visible="propertyRow.inspectionVisible" role="tabpanel">
      <b-card-body v-if="propertyRow.propertyInspections.length == 0" class="border">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <p class="mb-0">
            <i>No prior history</i>
          </p>
        </div>
      </b-card-body>
      <b-card-body v-else class="text-muted border">
        <ul
          class="verti-timeline list-unstyled ms-4"
          v-for="y in propertyRow.propertyInspections"
          :key="y.id"
        >
          <li
            class="event-list"
            :class="{
              active: y.status == 'PENDING',
            }"
          >
            <div class="event-timeline-dot pt-3">
              <i
                v-if="y.status == 'PENDING'"
                class="bx bxs-right-arrow-circle font-size-18 bx-fade-right"
              ></i>
              <i v-else class="bx bx-right-arrow-circle font-size-18"></i>
            </div>
            <div class="media">
              <div
                class="d-flex justify-content-end align-items-center pt-3 ms-4 me-3"
                style="width: 135px"
              >
                <div class="pe-1">
                  <b class="font-size-16">
                    {{ formatDateShort(new Date(y.inspectionDateTime)) }}
                  </b>
                </div>
                <div>
                  <i
                    class="bx bx-right-arrow-alt font-size-16 text-info align-middle ms-2"
                  ></i>
                </div>
              </div>
              <div class="media-body">
                <div class="card p-3">
                  <div class="row">
                    <div class="col-md-6 border-end border-3">
                      <div class="font-size-12 mb-1">
                        Property Status:
                        <b class="font-size-14">{{ y.propertyStatus }}</b>
                      </div>
                      <div class="font-size-12 mb-1">
                        Assessed Value:
                        <b class="font-size-14">{{ y.assessedValue }}</b>
                      </div>
                      <div class="font-size-12 mb-1">
                        Inspection Status:
                        <b class="font-size-14">{{ y.inspectionStatus }}</b>
                      </div>
                      <div class="font-size-12 mb-1">
                        Inspected By:
                        <b v-if="y.employee" class="font-size-14">
                          {{
                            y.employee.firstName.charAt(0).toUpperCase() +
                            y.employee.firstName.slice(1)
                          }}
                          {{
                            y.employee.middleName
                              ? `${y.employee.middleName.charAt(0).toUpperCase()}.`
                              : ""
                          }}
                          {{
                            y.employee.lastName.charAt(0).toUpperCase() +
                            y.employee.lastName.slice(1)
                          }}</b
                        >
                        <b v-else class="font-size-14">n/a</b>
                      </div>
                      <div class="font-size-16 mb-1">
                        <span
                          v-if="y.status == 'PENDING'"
                          class="badge bg-warning bg-soft text-warning"
                          ><b>{{ y.status }}</b></span
                        >
                        <span v-if="y.status == 'POSTED'" class="badge bg-success"
                          ><b>{{ y.status }}</b></span
                        >
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="font-size-13 mb-2">Attachments:</div>
                      <b-row style="max-height: 150px; overflow: auto">
                        <b-col
                          sm="4"
                          v-for="(z, index) in y.inspectionFiles"
                          :key="z.id"
                          class="mb-2"
                        >
                          <div
                            class="position-relative cursor-pointer"
                            :style="`z-index: ${y.inspectionFiles.length - index}`"
                          >
                            <div class="border p-3" @click="openDocument(z)">
                              <div>
                                <div class="avatar-xs me-3 mb-2">
                                  <div class="avatar-title bg-transparent rounded">
                                    <i
                                      v-if="z.fileType.includes('image')"
                                      class="mdi mdi-image font-size-24 text-purple"
                                    ></i>
                                    <i
                                      v-if="z.fileType.includes('application')"
                                      class="mdi mdi-file-pdf-outline font-size-24 text-danger"
                                    ></i>
                                  </div>
                                </div>
                                <div class="d-flex">
                                  <div class="overflow-hidden me-auto">
                                    <h5 class="font-size-14 text-truncate mb-1">
                                      {{ z.description }}
                                    </h5>
                                    <p class="text-muted mb-0">
                                      {{
                                        formatDateWithTime(new Date(z.dateTimeUploaded))
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </b-card-body>
    </b-collapse>
  </div>
</template>
